import {Component, inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerHomeComponent } from '../../customer/customer-home/customer-home.component';
import { PartnerHomeComponent } from '../../partner/partner-home/partner-home.component';
import { NavigationBarComponent } from '../navigation/navigation.component';
import { shareReplay } from 'rxjs/operators';
import { RightColumnComponent } from '../right-column/right-column.component';
import { CommonService } from '../../../core/api/services/utility-services/common.service';
import { SessionDto } from '../../../core/models/session/sessiondto';
import { LeftColumnComponent } from '../left-column/left-column.component';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { UrlConstants } from '../../../core/constants/url.constants';
import { RoleConstants } from '../../../core/constants/role.constants';
import { MenuConstants } from '../../../core/constants/menu.constants';
import { AppHeaderComponent } from '../app-header/app-header.component';
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    AppHeaderComponent,
    CommonModule,
    CustomerHomeComponent,
    PartnerHomeComponent,
    NavigationBarComponent,
    RouterModule,
    LeftColumnComponent,
    RightColumnComponent,
    TranslatePipe
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})

export default class HomeComponent implements OnInit {
  sessionDetails: SessionDto;

  isPartner: boolean;
  readonly commonService = inject(CommonService);

  readonly session$ = this.commonService.session().pipe(shareReplay(1));
  menuItems = [
    // Customers
    { path: UrlConstants.myProductsCustomerUrl, object: "homepage.customer.myProducts", role: RoleConstants.VIEW_CUSTOMER_PRODUCTS_PAGE },
    { path: UrlConstants.communicationsCustomerUrl, object: "homepage.communications", role: RoleConstants.VIEW_CUSTOMER_COMM_PAGE },
    { path: UrlConstants.promotionsCustomerUrl, object: "homepage.promotions", role: RoleConstants.VIEW_CUSTOMER_PROMO_PAGE },
    { path: UrlConstants.reportsCustomerUrl, object: "homepage.reports", role: RoleConstants.VIEW_CUSTOMER_REPORTS },
    { path: UrlConstants.trainingCustomerUrl, object: "homepage.training", role: RoleConstants.VIEW_CUSTOMER_TRAINING_PAGE },
    { path: UrlConstants.healthFairCustomerUrl, object: "homepage.healthFair", role: RoleConstants.VIEW_CUSTOMER_HEALTH_FAIR_PAGE },
    { path: UrlConstants.contactUsCustomerUrl, object: "homepage.contactUs", role: RoleConstants.VIEW_CUSTOMER_CONTACT_US_PAGE },

    //partners
    { path: UrlConstants.overviewPartnerUrl, object: "homepage.overview", role: RoleConstants.VIEW_PARTNER_OVERVIEW_PAGE },
    { path: UrlConstants.productsPartnerUrl, object: "homepage.partner.products", role: RoleConstants.VIEW_PARTNER_PRODUCTS_PAGE },
    { path: UrlConstants.salesInfoPartnerUrl, object: "homepage.sales", role: RoleConstants.VIEW_PARTNER_SALES_PAGE },
    { path: UrlConstants.communicationsPartnerUrl, object: "homepage.communications", role: RoleConstants.VIEW_PARTNER_COMM_PAGE },
    { path: UrlConstants.promotionsPartnerUrl, object: "homepage.promotions", role: [RoleConstants.VIEW_PARTNER_PROMO_PAGE, RoleConstants.PARTNER_ADMIN] },
    { path: UrlConstants.accountSearchPartnerUrl, object: "homepage.accounts", role: [RoleConstants.VIEW_PARTNER_ACCOUNTS, RoleConstants.VIEW_PARTNER_SALES_OFFICES, RoleConstants.VIEW_PARTNER_USERS] },
    { path: UrlConstants.reportsPartnerUrl, object: "homepage.reports", role: RoleConstants.VIEW_PARTNER_REPORTS },
    { path: UrlConstants.contactUsPartnerUrl, object: "homepage.contactUs", role: RoleConstants.VIEW_PARTNER_CONTACT_US_PAGE },
    { path: UrlConstants.clientFeedbackPartnerUrl, object: "homepage.clientFeedback", role: RoleConstants.VIEW_PARTNER_FEEDBACK_PAGE },
  ];

  ngOnInit() {
    let item = this.menuItems.find(menuItem => menuItem.path === UrlConstants.productsPartnerUrl && menuItem.role === RoleConstants.VIEW_PARTNER_PRODUCTS_PAGE)
    this.commonService.sessiondetails?.subscribe(res => {
      this.sessionDetails = res
      this.isPartner = this.accessible(RoleConstants.PARTNER);
      if (item && this.isPartner) {
        if (this.sessionDetails.hasProgramModels) {
          item.object = "homepage.programs";
          item.path = UrlConstants.programsPartnerUrl;
        }
      }
    })
  }
  accessible(role: string): boolean {
    return this.sessionDetails && this.sessionDetails.userRoles?.includes(role);
  }
  displayMenu(menuitem: any): boolean {
    if (menuitem.path === MenuConstants.ACCOUNTS) {
      return this.accessible(RoleConstants.VIEW_PARTNER_ACCOUNTS) || this.accessible(RoleConstants.VIEW_PARTNER_SALES_OFFICES) || this.accessible(RoleConstants.VIEW_PARTNER_USERS);
    } else if (typeof menuitem.role === "string") {
      return this.accessible(menuitem.role);
    } else {
      let accessibleItemCount = 0;
      menuitem.role.forEach((item: string) => {
        if (this.accessible(item)) {
          accessibleItemCount++;
        }
      })
      return menuitem.role.length === accessibleItemCount;
    }
  }
}
